import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8.366 18.028 11.238 16H15a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h1v2.25a.75.75 0 0 0 1.184.613zm2.872-3.528c-.31 0-.613.097-.866.275q-1.342.946-2.872 2.028V15.25a.75.75 0 0 0-.75-.75H5A1.5 1.5 0 0 1 3.5 13V6A1.5 1.5 0 0 1 5 4.5h10A1.5 1.5 0 0 1 16.5 6v7a1.5 1.5 0 0 1-1.5 1.5zm-4.488-7a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h6.5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75zm0 3a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h3.5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75z" })
});
export default SvgChatRegularIcon;
